import React, { useEffect, useContext } from "react";
import Layout from "./Layout/Layout.jsx";
import { Route, Routes } from "react-router-dom";
import { SecureRoutes, PublicRoutes } from "./routes/routes.js";
import { AppGlobalContext } from "./contexts/AppContext.context.js";
import { getUserRoleAndScreens } from "./services/authServices/auth.services.js";
import AuthMiddleware from "./routes/AuthMiddleware.js";
import FallbackUIForAccountNotAssigned from "./components/FallbackUIForAccountNotAssigned/FallbackUIForAccountNotAssigned.jsx";

function App() {
  const { isAuthUser, SetAppState } = useContext(AppGlobalContext);
  const { role, accountId } = getUserRoleAndScreens();

  useEffect(() => {
    const authToken = localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER);
    if (authToken) {
      const data = JSON.parse(authToken);
      SetAppState({
        isAuthUser: data,
        loggedInUserRole: data?.role,
        responsibilities: data?.pageAccess,
        assignedPlants: data?.assignedPlants,
        isFirstTimeLogin: data?.isFirstTimeLogin,
        isLocationIncharge: data?.isLocationIncharge,
        roleId: data?.roleId,
      });
    } else {
      localStorage.clear();
      SetAppState({
        isAuthUser: false,
        loggedInUserRole: null,
        responsibilities: null,
        authUserDetails: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Routes>
        {isAuthUser ||
        (role &&
          SecureRoutes.length > 0 &&
          localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)) ? (
          !accountId ? (
            <Route path="/" element={<FallbackUIForAccountNotAssigned />} />
          ) : (
            SecureRoutes.filter((route) => route.roles.includes(role)).map(
              (route, i) => (
                <Route
                  path={route.path}
                  element={
                    <AuthMiddleware>
                      <Layout>{route.element}</Layout>
                    </AuthMiddleware>
                  }
                  key={i}
                />
              )
            )
          )
        ) : (
          PublicRoutes.map((route, index) => (
            <Route path={route.path} element={route.element} key={index} />
          ))
        )}
      </Routes>
    </div>
  );
}

export default App;
